<template>
  <div :class="$style['container']">
    <div :class="$style['earning-box']">
      <div :class="$style['earning-box-text']">
        <CalendarIcon :class="$style['earning-box-text-icon']"/>Monthly deposits
      </div>
      <div :class="$style['earning-box-infos']">
        <span :class="$style['earning-box-infos-date']">
          {{ currentMonth }} {{ currentYear }}
        </span>
        <span :class="$style['earning-box-infos-value']">
          {{ depositsMonthly !== null ? formatToUSD(depositsMonthly) : '--'}}
        </span>
      </div>
    </div>
    <div :class="$style['earning-box']">
      <div :class="$style['earning-box-text']">
        <CalendarIcon :class="$style['earning-box-text-icon']"/>Daily earnings projection
      </div>
      <div :class="$style['earning-box-infos']">
        <span :class="$style['earning-box-infos-date']">
          <span :class="$style['earning-box-infos-date-f38']">{{ currentDay }}</span> {{ currentMonth }}
        </span>
        <span :class="$style['earning-box-infos-value']">
          {{ projectionDaily !== null ? formatToUSD(projectionDaily) : '--' }}
        </span>
      </div>
    </div>
    <div :class="$style['earning-box']">
      <div :class="$style['earning-box-text']">
        <CalendarIcon :class="$style['earning-box-text-icon']"/>Monthly earnings projection
      </div>
      <div :class="$style['earning-box-infos']">
        <span :class="$style['earning-box-infos-date']">
          {{ currentMonth }} {{ currentYear }}
        </span>
        <span :class="$style['earning-box-infos-value']">
          {{ projectionMonth !== null ? formatToUSD(projectionMonth) : '--' }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatToUSD } from '@/helpers/currencyFormatter';
import { CalendarIcon } from '@heroicons/vue/24/outline';

export default {
  name: 'EarningsProjections',

  props: {
    projectionDaily: {
      type: Number,
      default: 0,
    },
    projectionMonth: {
      type: Number,
      default: 0,
    },
    depositsMonthly: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      currentDay: this.getCurrentDay(),
      currentMonth: this.getCurrentMonth(),
      currentYear: this.getCurrentYear()
    }
  },

  components: {
    CalendarIcon,
  },

  methods: {
    formatToUSD,
    getCurrentMonth(date = new Date()) {
      return date.toLocaleString('en-US', { month: 'short'});
    },
    getCurrentYear(date = new Date()) {
      return date.toLocaleString('en-US', { year: 'numeric' });
    },
    getCurrentDay(locale = 'en-US', date = new Date()) {
      return date.toLocaleString(locale, { day: 'numeric' });
    }
  }
}
</script>

<!-- TODO quando for mobile deixar na msm linha -->

<style lang="scss" module>
  .container {
    display: grid;
    gap: 25px;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));

    @include respond-to(null, 'sm') {
      gap: 10px !important;
      grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
    }
  }

  .earning-box {
    display: flex;
    // width: 483px;
    padding: 18px 31px;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    align-self: stretch;
    border-radius: 16px;
    background: rgba(45, 45, 45, 0.35);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);



    @include respond-to(null, 'xs') {
      padding: 10px !important;
    }

    &-text {
      color: #C1C1C1;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 26px;
      display: flex;
      align-content: center;

      @include respond-to(null, 'xs') {
        font-size: 14px !important;
      }

      &-icon {
        width: 16px;
        color: #BBF90A;
        margin-right: 10px;
      }
    }

    &-infos {
      display: flex;
      align-items: center;
      gap: 20px;
      flex-wrap: wrap;
      justify-content: center;

      &-date {
        border-radius: 8px;
        background: #0B0C0C;
        display: flex;
        padding: 12px 18px;
        align-items: center;
        gap: 8px;color: #2FE0D5;
        text-align: center;
        font-size: 22px;
        font-style: normal;
        font-weight: 600;
        line-height: 32px;
        width: 110px;

        @include respond-to(null, 'xs') {
          display: none !important;
          font-size: 16px !important;
          width: 100px !important;
          padding: 12px 18px !important;
          justify-content: center !important;
        }

        &-f38 {
          font-size: 36px;

          @include respond-to(null, 'xs') {
            font-size: 28px !important;
          }
        }
      }
  
      &-value {
        color: #2FE0D5;
        text-align: center;
        font-size: 42px;
        font-style: normal;
        font-weight: 600;
        line-height: 32px;

        @include respond-to(null, 'xs') {
          font-size: 24px !important;
        }
      }
    }

  }
</style>
